var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"about-title"},[_c('div',{staticClass:"about-text"},[_vm._v(_vm._s(_vm.title))]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-bottom"},[_c('div'),_c('div')])
}]

export { render, staticRenderFns }